// extracted by css-extract-rspack-plugin
export default {"root":"HgLs9H"};